export const baseGameConfig = {
  colors: {
    health: 0xff0000,
  },
  sizes: {
    health: {
      width: 30,
      height: 5,
    },
  },
};
